import React, { useState } from "react";
import { orderBy } from "@progress/kendo-data-query";
import { Grid } from "@progress/kendo-react-grid";
import { GridColumn as Column } from "@progress/kendo-react-grid";

/**
 * InstanceTaskTable Component
 * @author Abhishek Dhillon
 */
const InstanceTaskTable = React.memo(({ columns, data, height = "415px" }) => {
  const [sort, setSort] = useState([{ field: "DueDate", dir: "desc" }]);
  return (
    <div className='table-main-container p-3 instance-task-table'>
      <Grid
        data={orderBy(data, sort)}
        resizable={true}
        size='small'
        style={{ maxHeight: height, overflowY: "auto" }}
        sortable={true}
        sort={sort}
        onSortChange={(e) => setSort(e.sort)}>
        {columns.map((column) => (
          <Column
            key={column.field}
            field={column.field}
            title={column.title}
            width={column.width}
            format={column.format}
            cell={column.cell}
            sortable={column.sortable}
          />
        ))}
      </Grid>
    </div>
  );
});

export default InstanceTaskTable;
